import { render } from "./AppFooter.vue?vue&type=template&id=0da2722a&ts=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/home/mateusz/Workspace/Planer Ślubu/planer-slubu-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__